import {Link} from 'react-router-dom';
import {ExtLinksContainer} from './exterior-links.styles.jsx';

// Placeholder file in the event I add exterior link on the Home page
const ExteriorLinks = () => {
  
  return (
    <ExtLinksContainer>
      {/* <a href='https://www.ebay.com/usr/yawefe5' >
        <img src='../../assets/ebay-logo.png' alt='eBay Logo' ></img>
        
      </a> */}
    </ExtLinksContainer>
  );
}

export default ExteriorLinks;
